import React, { useEffect } from "react";
import Modal from "react-responsive-modal";
import "../../styles/CustomModal.css";
import "react-responsive-modal/styles.css";
import styled from "styled-components";

const RejectConfirmModal = (oProps: {
  isVisible: boolean;
  setVisible: any;
  type?: string;
  onPause?: any;
  onConfirm?: any;
}) => {
  const onCloseModal = () => {
    oProps.setVisible(false);
  };

  useEffect(() => {
    if (oProps.isVisible) {
      const handleKey = (event: KeyboardEvent) => {
        if (event.key === "Enter") {
          oProps.onConfirm(false);
        }
      };
      window.addEventListener("keydown", handleKey);
      return () => {
        window.removeEventListener("keydown", handleKey);
      };
    }
  }, []);

  return (
    <Modal
      open={oProps.isVisible}
      onClose={onCloseModal}
      center
      classNames={{
        overlay: "optionCustomOverlay",
        modal: "rejectConfirmModal",
      }}
      closeOnOverlayClick={false}
      showCloseIcon={false}
      animationDuration={150}
    >
      <Style>
        <div className="modal">
          <img
            className="closeIcon"
            onClick={onCloseModal}
            src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_close.svg`}
            alt="ic"
          />

          <p className="titleFont">주문을 정말 취소하시나요?</p>
          <p className="subTitle">
            {(!oProps.type || oProps.type !== "재료 소진") && (
              <span>※주의</span>
            )}
            {oProps.type && oProps.type === "재료 소진"
              ? "재료 소진된 메뉴와 옵션을\n모두 정확히 선택하셨나요?\n고객님께 주문취소 메시지가 전송됩니다"
              : ` 확인 버튼을 누르면 결제가 취소되고 주문은 복원되지않습니다. 현재 주문을 수행할 수 없다면 임시영업중지 설정바랍니다.`}
          </p>

          <div className="bottomButtonWrap">
            <div className="cancelButton" onClick={onCloseModal}>
              취소
            </div>
            <div className="confirmButton" onClick={oProps.onConfirm}>
              확인
            </div>
          </div>
        </div>
      </Style>
    </Modal>
  );
};

export default RejectConfirmModal;

const Style = styled.div`
  .modal {
    width: 100%;
  }

  .closeIcon {
    position: absolute;
    top: 5%;
    right: 4%;
    cursor: pointer;
  }

  .titleFont {
    padding-top: 70px;
    font-size: 28px;
    line-height: 40px;
    font-weight: 500;
    color: #000000;
    text-align: center;
  }
  .subTitle {
    padding-top: 20px;
    padding-bottom: 60px;
    font-size: 20px;
    line-height: 32px;
    font-weight: 400;
    color: #000000;
    text-align: center;
    white-space: pre-line;
    span {
      color: #ff616b;
      font-weight: 600;
    }
  }

  .bottomButtonWrap {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;

    .cancelButton {
      width: 100%;
      padding: 16px;
      font-size: 24px;
      line-height: 32px;
      border-radius: 10px;
      font-weight: 600;
      text-align: center;
      cursor: pointer;
      color: #ff616b;
      background: #ffffff;
      border: 1px solid #ff616b;
    }

    .confirmButton {
      width: 100%;
      padding: 16px;
      font-size: 24px;
      line-height: 32px;
      border-radius: 10px;
      font-weight: 600;
      text-align: center;
      cursor: pointer;
      color: #ffffff;
      background: #4dd2ae;
      border: 1px solid #4dd2ae;
    }
  }
`;
